module.exports = __webpack_public_path__ + "static/assets/9905d7791a40b5238b05a398692c2ab9.png";